import { CaseUserGroup } from '@/api/apis/case';
import { EmployeeRole } from '@/api/apis/resources';
import { EMPLOYEE_ROLE_NAMES } from '@/constants/user.constants';
import { MINUTE_IN_MS } from '@/constants/date.constants';
import { BulkAssignmentFiltersType } from './types';

export const BULK_ASSIGNMENT_FILTERS: BulkAssignmentFiltersType = {
  organType: [],
  group: [],
  employeeIdsToDetach: [],
  employeeIdsToAssign: [],
};

export const BULK_ASSIGNMENT_COLUMNS = [
  { key: 'case', label: 'CASE', isSortable: false },
  { key: 'status', label: 'STATUS', isSortable: false },
  { key: 'donorORTime', label: 'OR TIME', isSortable: true },
  { key: 'businessRegion', label: 'BUSINESS REGION', isSortable: false },
];

export const BULK_ASSIGNMENT_ROLES_LIST = [
  {
    value: CaseUserGroup.AviationSpecialists,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.AviationSpecialist],
  },
  {
    value: CaseUserGroup.ClinicalCoordinators,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.ClinicalCoordinator],
  },
  {
    value: CaseUserGroup.ClinicalLeads,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.ClinicalLead],
  },
  {
    value: CaseUserGroup.GroundSpecialists,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.GroundSpecialist],
  },
  {
    value: CaseUserGroup.LogisticsManagers,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.LogisticsManager],
  },
  {
    value: CaseUserGroup.OrganManagementSpecialists,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.OrganManagementSpecialist],
  },
  {
    value: CaseUserGroup.SrLogisticsManagers,
    name: EMPLOYEE_ROLE_NAMES[EmployeeRole.SrLogisticsManager],
  },
];

export const DISABLED_DETACH_ONLY_GROUPS = [
  CaseUserGroup.ClinicalCoordinators,
  CaseUserGroup.OrganManagementSpecialists,
];

/** How often the authoritative status endpoint is polled while a run is in progress. */
export const BULK_ASSIGNMENT_STATUS_POLL_MS = MINUTE_IN_MS / 6;

/**
 * The backend returns 202 from the start request before the worker inserts the saga row, so for a
 * short window our own run legitimately reports "nothing active". Don't close the modal during it.
 */
export const BULK_ASSIGNMENT_START_GRACE_MS = MINUTE_IN_MS / 6;

/** Absolute ceiling on how long the blocking modal may stay open. */
export const BULK_ASSIGNMENT_HARD_TIMEOUT_MS = MINUTE_IN_MS * 10;

export const GROUP_ROLE_NAME_MAP: Partial<Record<CaseUserGroup, string>> = {
  [CaseUserGroup.OrganManagementSpecialists]: EMPLOYEE_ROLE_NAMES[EmployeeRole.OrganManagementSpecialist],
  [CaseUserGroup.ClinicalCoordinators]: EMPLOYEE_ROLE_NAMES[EmployeeRole.ClinicalCoordinator],
};
